
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { AppDataProvider } from "@/contexts/AppDataContext";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Employees from "./pages/Employees";
import EmployeeDetail from "./pages/EmployeeDetail";
import Payroll from "./pages/Payroll";
import PayrollReview from "./pages/PayrollReview";
import Payslips from "./pages/Payslips";
import Team from "./pages/Team";
import Settings from "./pages/Settings";
import Loans from "./pages/Loans";
import Leave from "./pages/Leave";
import Attendance from "./pages/Attendance";
import NotFound from "./pages/NotFound";

// Add new placeholder pages for the new routes
import Departments from "./pages/Departments";
import Users from "./pages/Users";
import Permissions from "./pages/Permissions";
import Company from "./pages/Company";
import Profile from "./pages/Profile";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <AuthProvider>
        <AppDataProvider>
          <Toaster />
          <Sonner />
          <Routes>
            <Route path="/" element={<Navigate to="/login" />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/employees" element={<Employees />} />
            <Route path="/employees/:id" element={<EmployeeDetail />} />
            <Route path="/payroll" element={<Payroll />} />
            <Route path="/payroll/review" element={<PayrollReview />} />
            <Route path="/payslips" element={<Payslips />} />
            <Route path="/attendance" element={<Attendance />} />
            <Route path="/leave" element={<Leave />} />
            <Route path="/loans" element={<Loans />} />
            <Route path="/team" element={<Team />} />
            <Route path="/settings" element={<Settings />} />
            
            {/* New routes */}
            <Route path="/departments" element={<Departments />} />
            <Route path="/users" element={<Users />} />
            <Route path="/permissions" element={<Permissions />} />
            <Route path="/company" element={<Company />} />
            <Route path="/profile" element={<Profile />} />
            
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AppDataProvider>
      </AuthProvider>
    </BrowserRouter>
  </QueryClientProvider>
);

export default App;
